import { render, staticRenderFns } from "./OrderAdd.vue?vue&type=template&id=0a0ce57f&scoped=true&"
import script from "./OrderAdd.vue?vue&type=script&lang=js&"
export * from "./OrderAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0ce57f",
  null
  
)

export default component.exports